import { Component, AfterViewInit, ElementRef, TemplateRef, HostListener, ChangeDetectionStrategy, viewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslocoDirective } from '@jsverse/transloco'
import { ModalServiceV2 } from '../../../../services/modal-v2.service'
import { AsTypePipe } from '../../../pipes/as.pipe'

@Component({
	selector: 'app-modal-v2',
	standalone: true,
	imports: [CommonModule, TranslocoDirective, AsTypePipe],
	templateUrl: './modal-v2.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./modal-v2.component.css']
})
export class AppModalComponent implements AfterViewInit {
	// Not required: the trap lives inside @if (state().isOpen), so a closed modal
	// has no element and viewChild.required() would throw instead of answering undefined.
	readonly focusTrapRef = viewChild<ElementRef<HTMLDivElement>>('focusTrap')

	@HostListener('document:keydown.escape')
	onEscape(): void {
		this.handleKeydownEscape()
	}

	// Helper to access signal value easily in template
	get state() { return this.modalServiceV2.modalState }

	constructor(
		public modalServiceV2: ModalServiceV2
	) {}

	ngAfterViewInit() {
		setTimeout(() => {
			this.focusTrapRef()?.nativeElement.focus()
		})
	}

	close() {
		this.modalServiceV2.close()
	}

	onOverlayClick(event: MouseEvent): void {
		const isOverlayClicked = (event.target as HTMLElement).classList.contains('modal-overlay')
		const canModalBeClosed = this.modalServiceV2.modalState().config.closable === true
		if (isOverlayClicked && canModalBeClosed) {
			this.close()
		}
	}

	// Type Guards helpers for the template
	isString(val: unknown): boolean { return typeof val === 'string' }
	isTemplate(val: unknown): boolean { return val instanceof TemplateRef }
	asTemplate(val: unknown): TemplateRef<unknown> { return val as TemplateRef<unknown> }

	private handleKeydownEscape() {
		// ESC key closes modal
		if (this.modalServiceV2.modalState().config.closable === true) {
			this.close()
		}
	}
}
